import React from "react";
import { Route, Navigate } from "react-router-dom";
import { isAuthenticated } from "../services/account.service";
import Loader from "../common/loader";
import NotFoundPage from "../components/errors/404";
import { ROLES } from "../constants/general.constant";
import AdminBusiness from "../components/admin/business";
import BusinessDetails from "../components/admin/business/businessDetails";
import CustomerDetails from "../components/admin/customer/CustomerDetails";
import MainLayout from "../layout/mainLayout";
import {useAuth} from "../hook/userRoleHook";
import AdminBankers from "../components/admin/bankers";
import {AdminBankerDetails} from "../components/admin/bankers/BankerDetails";
import AdminActivityLogs from "../components/admin/activityLogs";
import Notifications from "../components/customers/notifications";

const ProtectedRoute: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const { role, loading, redirectionUrl, isLoginPage } = useAuth();

  if (!isAuthenticated() && !isLoginPage) {
    return <Navigate to={redirectionUrl} replace />;
  }

  if (loading) return <Loader />;

  if (role !== ROLES.ADMIN) return <NotFoundPage />;

  return <>{children}</>;
};

const WithLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>
    <MainLayout>{children}</MainLayout>
  </ProtectedRoute>
);

const WithoutLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => (
  <ProtectedRoute>{children}</ProtectedRoute>
);

const adminRoutesConfig = [
  { key: "Business", path: "/admin/business", element: <AdminBusiness />, layout: "with" },
  { key: "BusinessDetails", path: "/admin/business-details/:id", element: <BusinessDetails />, layout: "with" },
  { key: "CustomerDetails", path: "/admin/customer/:id", element: <CustomerDetails />, layout: "with" },
  { key: "Business", path: "/admin/bankers", element: <AdminBankers />, layout: "with" },
  { key: "Business", path: "/admin/banker-details/:id", element: <AdminBankerDetails />, layout: "with" },
  { key: "Notifications", path: "/admin/notifications", element: <Notifications />, layout: "with" },
  { key: "ActivityLogs", path: "/admin/activity-logs", element: <AdminActivityLogs />, layout: "with" },
];

const AdminRoutes = adminRoutesConfig.map(({ key, path, element, layout }) => (
  <Route
    key={key}
    path={path}
    element={layout === "with" ? <WithLayout>{element}</WithLayout> : <WithoutLayout>{element}</WithoutLayout>}
  />
));

export default AdminRoutes;
